import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/passengers';

class passengersService {
    /**
     * Tworzy nowego pasażera, wysyłając dane pasażera do endpointu.
     * 
     * @param {Object} passenger - Obiekt zawierający dane nowego pasażera.
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera po pomyślnym utworzeniu pasażera.
     */
    createPassenger(passenger) {
        return axios.post(API_URL, passenger);
    }

    /**
     * Pobiera listę wszystkich pasażerów.
     * 
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera zawierającą listę wszystkich pasażerów.
     */
    getAllPassengers() {
        return axios.get(API_URL);
    }

    /**
     * Pobiera dane pasażera na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID pasażera, którego chcemy pobrać.
     * @returns {Promise<Object>} Zwraca dane pasażera o podanym ID.
     */
    getPassengerById(id) {
        return axios.get(`${API_URL}/${id}`);
    }

    /**
     * Aktualizuje dane pasażera na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID pasażera, którego chcemy zaktualizować.
     * @param {Object} updatedPassenger - Obiekt zawierający zaktualizowane dane pasażera.
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera po pomyślnej aktualizacji danych pasażera.
     */
    updatePassenger(id, updatedPassenger) {
        return axios.put(`${API_URL}/${id}`, updatedPassenger);
    }

    /**
     * Usuwa pasażera na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID pasażera, którego chcemy usunąć.
     * @returns {Promise<void>} Zwraca odpowiedź z serwera po pomyślnym usunięciu pasażera.
     */
    deletePassenger(id) {
        return axios.delete(`${API_URL}/${id}`);
    }
}

export default new passengersService();
